import { useTranslation } from "react-i18next";
import { Translate } from "@phosphor-icons/react";

/**
 * Compact language toggle for public/marketing pages (Landing, Login, About).
 * Shows the *other* language as the action label — one tap swaps.
 */
export function LanguageToggle({ className = "", compact = false }) {
  const { i18n } = useTranslation();
  const isFr = (i18n.language || "fr").startsWith("fr");
  const nextLang = isFr ? "en" : "fr";
  const label = isFr ? "EN" : "FR";
  const aria = isFr ? "Switch to English" : "Passer en français";
  const toggle = () => i18n.changeLanguage(nextLang);
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={aria}
      title={aria}
      data-testid="language-toggle"
      className={`inline-flex items-center gap-1.5 rounded-full border border-border bg-card/80 hover:bg-card px-3 py-1.5 text-xs font-semibold tracking-wide transition-colors ${className}`}
    >
      <Translate size={14} weight="duotone" className="text-accent" />
      {!compact && <span>{label}</span>}
    </button>
  );
}

export default LanguageToggle;
